import { FC, useState } from "react";
import type { SuperTrendSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "atrPeriod" | "multiplier";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string; min: number; max: number }[] = [
  { key: "atrPeriod", label: "ATR Period", min: 1, max: 100 },
  { key: "multiplier", label: "Multiplier", min: 1, max: 5 },
];

interface Props {
  settings: SuperTrendSettings;
  onChange: (settings: SuperTrendSettings) => void;
}

export const SuperTrendInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    atrPeriod: String(settings.atrPeriod),
    multiplier: String(settings.multiplier),
  });

  const handleChange = (key: InputKey, value: string) =>
    setValues((prev) => ({ ...prev, [key]: value }));

  const handleBlur = (key: InputKey) => {
    const field = FIELDS.find((f) => f.key === key)!;
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(field.min, parsed), field.max);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label, min, max }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={min}
            max={max}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key)}
          />
        </div>
      ))}
    </div>
  );
};
